/***
 * 创建人：段锐
 * 时间：2019-06-11
 * 描述：指令-绑定 SwAudio 的指令的元素提供音频播放功能
 * 更新说明:
 */
import { Directive, ElementRef, HostListener } from '@angular/core';
import { SwAudioService } from './sw-audio.service';


/**
 * SwAudio 的指令的元素提供音频播放功能  SwAudio
 * 
 *  @example eg:<button type="button" class="btn btn-default" data-src="../assets/demo/img/dcd.mp4" data-title="JJJ" SwVideo>视频播放指令</button>
 */
@Directive({
  selector: '[SwAudio]'
})
export class SwAudioDirective {


  /**
   * @param audio  音频服务
   * @ignore
   */
  constructor(public audio: SwAudioService) { }

  /**
   * @ignore
   */
  @HostListener('click', ['$event']) onClick(event) {
    //获取到表单业务id
    let src = event.target.getAttribute("data-src");
    let title = event.target.getAttribute("data-title");
    //创建审核组件
    this.audio.openAudio(title, src);
  }
}
